const appRoutes = {
  admin: {
    artistExclusions: {
      index: () => "/admin/exclusions",
    },
    contentBlocks: {
      index: () => "/admin/content_blocks",
    },
    management: {
      index: () => "/admin/management",
    },
    pressItems: {
      index: () => "/admin/press",
    },
    studioEvents: {
      index: () => "/admin/studio_events",
    },
  },
};

export { appRoutes };
